module.exports = __webpack_public_path__ + "static/media/saved_boatramp_marker.a1f566bd.svg";